import axios from "axios";

// axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
// axios.defaults.baseURL = "http://aaw.no";

axios.defaults.baseURL = window.restaurant.base_url;

export default axios;
// module.exports = axios;


// WEBPACK FOOTER //
// ./src/components/axios.js